export default __webpack_public_path__ + "static/media/25.9ab0b623.svg";